import React from "react";
import { styled } from "@mui/material/styles";
import { InputLabel, Slider } from "@mui/material";
import Box from "@mui/material/Box";

const StyledBox = styled(Box, {
    shouldForwardProp: (prop) => !["label", "valueLabelFormat", "valueLabelDisplay"].includes(prop),
})(({
    theme, label, valueLabelFormat, valueLabelDisplay,
}) => ({
    "& .MuiSlider-markLabel": {
        fontSize: "11px",
        transform: "translateX(-100%)",
        '&[data-index="0"]': {
            transform: "none",
        },
    },

    "& .Mui-disabled fieldset": {
        backgroundColor: theme.palette.action.disabledBackground,
    },
    "& .Mui-disabled": {
        color: `${theme.palette.text.primary}!important`,
        WebkitTextFillColor: "initial",
    },
    "& .MuiInputLabel-shrink": {
        fontSize: 12,
        transform: "translate(2px, -7px) scale(1) !important",
    },
    "& .MuiOutlinedInput-notchedOutline legend": {
        display: "none",
    },

    ...label ? {
        height: 36,
        "& .MuiSlider-root": {
            marginTop: (valueLabelFormat || valueLabelDisplay === "on") && "15px",
        },
    } : {
        height: 24,
    },
}));

function CustomSlider(props) {
    const {
        onChange,
        label,
        disabled,
        marks,
        maxValue,
        minValue,
        step,
        value,
        valueLabelDisplay = "auto",
        valueLabelFormat,
    } = props;

    const handleChange = (event, newValue) => {
        onChange(newValue);
    };

    return (
        <StyledBox
            sx={{ width: "100%" }}
            label={label}
            valueLabelDisplay={valueLabelDisplay}
            valueLabelFormat={valueLabelFormat}
        >
            {label ? (
                <InputLabel>
                    {label}
                </InputLabel>
            ) : null}
            <Slider
                disabled={disabled}
                getAriaLabel={() => "Temperature range"}
                value={value}
                sx={{ width: "100%" }}
                max={maxValue}
                min={minValue}
                onChange={handleChange}
                marks={marks}
                step={step}
                valueLabelDisplay={valueLabelDisplay}
                valueLabelFormat={valueLabelFormat}
            />
        </StyledBox>
    );
}

export default CustomSlider;
